import * as React from "react";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { ImpactRedirectAction } from "../../../../../../Shared/Impact/Action/ImpactRedirectAction";
import { ImpactRedirectType } from "../../../../../../../Wrap/Models/Domains/Impact/ImpactRedirectType";

interface IEsgAccountSelectorProps {
    accounts: ClientAccount[];
    isPopUp: boolean;
    onClose: (val: boolean) => void;
}

interface IEsgAccountSelectorState {
    selectedHeadAccount: ClientAccount;
}

export class EsgAccountSelector extends React.Component<IEsgAccountSelectorProps, IEsgAccountSelectorState> {
    constructor(props: IEsgAccountSelectorProps) {
        super(props);
        this.state = {
            selectedHeadAccount: null
        };
    }
    componentDidMount() {
        if (!!this.props.accounts[0]?.HierarchyId) {
            this.setState({
                selectedHeadAccount: this.props.accounts[0]
            });
        }
    }
    public render(): JSX.Element {
        const { isPopUp, onClose, accounts } = this.props;

        return (
            <div>
                <Lightbox
                    show={isPopUp}
                    title={"Select an account"}
                    contentAfterTitle={null}
                    onClose={() => onClose(false)}
                    type={LightboxType.Modal}
                    unclosable={false}
                    noOverlay={false}
                    noAutofocus={false}
                    cssWrapper={"wider is-default-lightbox is-wide"}
                >
                    <div className="col-12 col-md-5">
                        <SelectEditor
                            key="HeadAccountView"
                            label=""
                            placeholder="Please select"
                            disabled={false} 
                            selected={this.state.selectedHeadAccount}               
                            options={accounts}
                            getText={(x) => {
                                const account = accounts.find((o) => o.HierarchyId == x.HierarchyId);
                                return `${account?.AccountName} ${account?.HeadClAccountId}`;
                            }}
                            onChange={(account) => {
                                this.setState({ selectedHeadAccount: account })
                            }}
                        />
                        <button
                            className="btn secondary"
                            onClick={() => ImpactRedirectAction.redirectToImpact(this.state.selectedHeadAccount?.HeadClAccountId, ImpactRedirectType.Overview)}
                            disabled={!this.state.selectedHeadAccount}>
                                Launch ESG Hub
                        </button>
                    </div>
                </Lightbox>
            </div>
        );
    }
}
